// guard-patrol.actions.ts
import { Action } from '@ngrx/store';
import {
  UserPatrolData,
  PatrolSession,
  PatrolViolation,
} from '../states/guard-patrol.state';

export class LoadUserPatrolData implements Action {
  readonly type = '[Guard Patrol] Load User Patrol Data';
}

export class LoadUserPatrolDataSuccess implements Action {
  readonly type = '[Guard Patrol] Load User Patrol Data Success';
  constructor(public payload: UserPatrolData) {}
}

export class LoadUserPatrolDataFailure implements Action {
  readonly type = '[Guard Patrol] Load User Patrol Data Failure';
  constructor(public payload: string) {}
}

export class StartPatrolling implements Action {
  readonly type = '[Guard Patrol] Start Patrolling';
  constructor(
    public payload: {
      geofenceId: string;
      startLatitude?: number;
      startLongitude?: number;
    }
  ) {}
}

export class StartPatrollingSuccess implements Action {
  readonly type = '[Guard Patrol] Start Patrolling Success';
  constructor(public payload: PatrolSession) {}
}

export class StartPatrollingFailure implements Action {
  readonly type = '[Guard Patrol] Start Patrolling Failure';
  constructor(public payload: string) {}
}

export class EndPatrolling implements Action {
  readonly type = '[Guard Patrol] End Patrolling';
  constructor(
    public payload: {
      sessionId: string;
      endLatitude?: number;
      endLongitude?: number;
      monitoringData?: any;
    }
  ) {}
}

export class EndPatrollingSuccess implements Action {
  readonly type = '[Guard Patrol] End Patrolling Success';
}

export class EndPatrollingFailure implements Action {
  readonly type = '[Guard Patrol] End Patrolling Failure';
  constructor(public payload: string) {}
}

export class GetPatrolSessions implements Action {
  readonly type = '[Guard Patrol] Get Patrol Sessions';
}

export class GetPatrolSessionsSuccess implements Action {
  readonly type = '[Guard Patrol] Get Patrol Sessions Success';
  constructor(public payload: PatrolSession[]) {}
}

export class GetPatrolSessionsFailure implements Action {
  readonly type = '[Guard Patrol] Get Patrol Sessions Failure';
  constructor(public payload: string) {}
}

export class GetUserPatrolSessions implements Action {
  readonly type = '[Guard Patrol] Get User Patrol Sessions';
}

export class GetUserPatrolSessionsSuccess implements Action {
  readonly type = '[Guard Patrol] Get User Patrol Sessions Success';
  constructor(public payload: PatrolSession[]) {}
}

export class GetUserPatrolSessionsFailure implements Action {
  readonly type = '[Guard Patrol] Get User Patrol Sessions Failure';
  constructor(public payload: string) {}
}

export class GetPatrolViolations implements Action {
  readonly type = '[Guard Patrol] Get Patrol Violations';
}

export class GetPatrolViolationsSuccess implements Action {
  readonly type = '[Guard Patrol] Get Patrol Violations Success';
  constructor(public payload: PatrolViolation[]) {}
}

export class GetPatrolViolationsFailure implements Action {
  readonly type = '[Guard Patrol] Get Patrol Violations Failure';
  constructor(public payload: string) {}
}

export class RecordPatrolViolation implements Action {
  readonly type = '[Guard Patrol] Record Patrol Violation';
  constructor(
    public payload: {
      sessionId: string;
      geofenceId: string;
      userId: string;
      userName: string;
      violationType: string;
      latitude?: number;
      longitude?: number;
      distanceOutside?: number;
      userRole?: string;
    }
  ) {}
}

export class RecordPatrolViolationSuccess implements Action {
  readonly type = '[Guard Patrol] Record Patrol Violation Success';
  constructor(public payload: PatrolViolation) {}
}

export class RecordPatrolViolationFailure implements Action {
  readonly type = '[Guard Patrol] Record Patrol Violation Failure';
  constructor(public payload: string) {}
}

export class SetCurrentPatrolSession implements Action {
  readonly type = '[Guard Patrol] Set Current Patrol Session';
  constructor(public payload: PatrolSession | null) {}
}

export class ClearPatrolData implements Action {
  readonly type = '[Guard Patrol] Clear Patrol Data';
}

export type GuardPatrolActions =
  | LoadUserPatrolData
  | LoadUserPatrolDataSuccess
  | LoadUserPatrolDataFailure
  | StartPatrolling
  | StartPatrollingSuccess
  | StartPatrollingFailure
  | EndPatrolling
  | EndPatrollingSuccess
  | EndPatrollingFailure
  | GetPatrolSessions
  | GetPatrolSessionsSuccess
  | GetPatrolSessionsFailure
  | GetUserPatrolSessions
  | GetUserPatrolSessionsSuccess
  | GetUserPatrolSessionsFailure
  | GetPatrolViolations
  | GetPatrolViolationsSuccess
  | GetPatrolViolationsFailure
  | RecordPatrolViolation
  | RecordPatrolViolationSuccess
  | RecordPatrolViolationFailure
  | SetCurrentPatrolSession
  | ClearPatrolData;
